<template>
    <div>
        <div class="card hide-while-loading">
            <div class="card-body">
                <div class="table-responsive" v-if="!loading">
                    <table class="table rounded-lg shadow" v-if="assets && assets.length > 0">
                        <thead class="bg-white border border-gray-50">
                            <tr>
                                <th class="py-3">Asset Name</th>
                                <th class="py-3">Primary Landlord</th>
                                <th class="py-3">Primary Tenant</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(asset, index) in assets" :key="asset.id" :class="index % 2 === 0 ? 'bg-gray-50' : ''">
                                <td>
                                    <a class="font-medium hover:text-indigo-800 transition duration-300 cursor-pointer"
                                       title="Click to view asset"
                                       :href="'/assets/' + asset.id"> {{ asset.name }}</a>
                                </td>

                                <td>
                                    {{ asset.landlord ? asset.landlord.full_name : null }}
                                </td>

                                <td>
                                    {{ asset.tenant ? asset.tenant.full_name : null }}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!--Empty View displayed if there are no assets -->
                    <div v-else class="card hide-while-loading text-center">
                        <div class="card-body">
                            <h4 class="card-title">No Assets</h4>
                            <div class="text-center">
                                <span class="">This asset group has no assets associated with it yet.</span>
                            </div>
                        </div>
                    </div>

                    <simple-pagination
                        v-if="paginationData && paginationData.last_page > 1"
                        :meta="paginationData"
                        padding="2"
                        @page-changed="fetchAssets">
                    </simple-pagination>
                </div>

                <div v-if="loading === true" class="flex justify-center items-center gap-2 py-12 text-md">
                    <icon-refresh class="h-10 w-10 text-indigo-600 animate-spin"/>
                    Loading assets...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "asset-group-assets",

    props: ["assetGroup"],

    data () {
        return {
            assets: {},
            paginationData: null,
            loading: false,
        };
    },

    mounted () {
        this.fetchAssets();
    },

    methods: {
        fetchAssets (paginationSettings = null) {
            this.loading = true;
            axios.get("/assets/groups/" + this.assetGroup.id + "/assets/index", {
                params: {
                    page: paginationSettings && paginationSettings.pageNumber ? paginationSettings.pageNumber : 1,
                    per_page: paginationSettings && paginationSettings.perPage ? paginationSettings.perPage : 10
                }
            }).then((response) => {
                this.assets = response.data.data;
                this.paginationData = response.data.meta;
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
                toastr.error("Could not fetch assets. Error: " + error.message);
            });
        },
    },
};
</script>